document.addEventListener('DOMContentLoaded', function() {
    // Tab switching logic (in case bootstrap JS is not hooked)
    document.querySelectorAll('.ai-models-tabs .nav-link').forEach(tab => {
        tab.addEventListener('click', function(e) {
            e.preventDefault();

            // Remove active state from all tabs
            const tabsList = this.closest('.ai-models-tabs');
            tabsList.querySelectorAll('.nav-link').forEach(t => {
                t.classList.remove('active');
            });

            // Add active state to clicked tab
            this.classList.add('active');

            // Hide all panes
            const targetId = this.getAttribute('href');
            const panesContainer = tabsList.nextElementSibling; // tab-content
            panesContainer.querySelectorAll('.tab-pane').forEach(p => {
                p.classList.remove('show', 'active');
            });

            // Show target pane
            const targetPane = document.querySelector(targetId);
            if (targetPane) {
                targetPane.classList.add('show', 'active');
            }
        });
    });

    function setupSorting(tableId) {
        const table = document.getElementById(tableId);
        if (!table) return;

        const headers = table.querySelectorAll('th.sortable');
        const tbody = table.querySelector('tbody');

        headers.forEach(header => {
            header.addEventListener('click', () => {
                const sortType = header.getAttribute('data-sort');
                const isAsc = header.classList.contains('asc');

                // Clear all sorts
                headers.forEach(h => {
                    h.classList.remove('asc', 'desc');
                });

                // Set new sort
                header.classList.add(isAsc ? 'desc' : 'asc');
                const direction = isAsc ? -1 : 1;

                // Get all rows (grouping data row and description row together)
                const rows = Array.from(tbody.querySelectorAll('.model-data-row'));
                const groups = rows.map(row => {
                    return {
                        dataRow: row,
                        descRow: row.nextElementSibling,
                        value: sortType === 'name' ? row.getAttribute('data-' + sortType) : parseFloat(row.getAttribute('data-' + sortType))
                    };
                });

                groups.sort((a, b) => {
                    if (a.value < b.value) return -1 * direction;
                    if (a.value > b.value) return 1 * direction;
                    return 0;
                });

                // Append rows in new order
                groups.forEach(group => {
                    tbody.appendChild(group.dataRow);
                    tbody.appendChild(group.descRow);
                });
            });
        });
    }

    setupSorting('textModelsTable');
    setupSorting('imageModelsTable');
});
